import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common/common.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-access-forbidden',
    templateUrl: './access-forbidden.component.html',
    styleUrls: ['./access-forbidden.component.scss'],
    standalone: false
})
export class AccessForbiddenComponent implements OnInit {
  staticText: any = TranslationService.staticTextData;

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    // this._common.getSetRouteValue(this.activated_route?.data);
  }

  goToHomePage() {
    this.router.navigate(['/']);
  }
}
